export const getQueryString = (name: string) => {
    const reg = `(^|&)${name}=([^&]*)(&|$)`;
    const r = window.location.search.substr(1).match(reg);
    if (r != null) {
        return unescape(r[2]);
    }
    return null;
};
